import { Route } from '@angular/router';
import { pagePermissionActivate } from '../page-permission';

/** CMS & content tools under `/content-hub/...` (default: `content-hub/news`). */
export const contentHubRoutes: Route = {
    path: 'content-hub',
    data: { title: 'content-hub' },
    children: [
        { path: '', pathMatch: 'full', redirectTo: 'news' },
        {
            path: 'content',
            loadComponent: () => import('./cms/content.component').then((m) => m.ContentComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'Content' },
        },
        {
            path: 'news',
            loadComponent: () => import('./news/news.component').then((m) => m.NewsComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'News' },
        },
        {
            path: 'livestock-ration-recommendation',
            loadComponent: () =>
                import('./livestock-ration-recommendation/livestock-ration-recommendation.component').then(
                    (m) => m.LivestockRationRecommendationComponent
                ),
            canActivate: pagePermissionActivate,
            data: { title: 'Livestock Ration Recommendation' },
        },
        {
            path: 'ration-recommendation',
            loadComponent: () =>
                import('./ration-recommendation/ration-recommendation.component').then((m) => m.RationRecommendationComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'Ration Recommendation' },
        },
        {
            path: 'grant-and-support',
            loadComponent: () =>
                import('./grant-and-support/grant-and-support.component').then((m) => m.GrantAndSupportComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'Grant And Support' },
        },
        {
            path: 'grant-and-support-record',
            loadComponent: () =>
                import('./grant-and-support-record/grant-and-support-record.component').then(
                    (m) => m.GrantAndSupportRecordComponent
                ),
            canActivate: pagePermissionActivate,
            data: { title: 'Grant And Support Record' },
        },
        {
            path: 'translation',
            loadComponent: () => import('./translation/translation.component').then((m) => m.TranslationComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'Translation' },
        },
    ],
};
